import {forwardRef, SVGProps} from 'react';

// eslint-disable-next-line react/display-name
export const EditNoteIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) =>
	<svg
		width='12'
		height='16'
		viewBox='0 0 12 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...props}
		ref={ref}
	>
		<path
			d='M7.5 0.833496H1.5C0.675 0.833496 0.00750017 1.5085 0.00750017 2.3335L0 14.3335C0 15.1585 0.6675 15.8335 1.4925 15.8335H10.5C11.325 15.8335 12 15.1585 12 14.3335V5.3335L7.5 0.833496ZM6.75 6.0835V1.9585L10.875 6.0835H6.75Z'
			fill='#0088CC'
		/>
	</svg>
);
